// extracted by mini-css-extract-plugin
export default {"container":"skills-page_container__Ol84F","content":"skills-page_content__cAheX"};